<template>
  <gg-modal :is-active="autorenewModalConfirmOpen" @close="closeModalAutorenewConfirm">
    <template v-slot:toolbar>
      Enabling Auto Renew
    </template>
    <template v-slot:body>
      <p>This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active.</p>

      <p>Are you sure you want to enable auto renewal?</p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="closeModalAutorenewConfirm">No</gg-btn>
      <gg-btn primary :loading="autorenewLoading" @click="acceptModalAutorenewConfirm">Yes</gg-btn>
    </template>
  </gg-modal>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AutorenewEnable',
  props: {
    crId: {
      type: [String, Number],
      required: true,
    },
    goToRoute: {
      type: [String, Boolean],
      required: false,
      default: false,
    }
  },
  data: () => ({
    autorenewModalConfirmOpen: true,
    autorenewLoading: false,
  }),

  computed: {
    ...mapGetters(['services', 'domains']),
    selectedService () {
      const domains = this.domains.filter(domain => domain.cancellation_id === parseInt(this.crId)).map(item => ({ id: item.id, type: item.cancellation_type }))
      if (domains.length) {
        return domains.at(0)
      }
      const hostings = this.services.filter(service => service.cancellation_id === parseInt(this.crId)).map(item => ({ id: item.id, type: item.cancellation_type }))
      if (hostings.length) {
        return hostings.at(0)
      }
      return false
    },
  },
  methods: {
    ...mapActions(['enableAutorenew', 'reportError']),

    async acceptModalAutorenewConfirm () {
      this.autorenewLoading = true
      try {
        await this.callEnableAutorenew()
      } finally {
        this.autorenewLoading = false
        this.closeModalAutorenewConfirm()
      }
    },

    async callEnableAutorenew () {
      if (!this.selectedService) {
        this.reportError('Can not define service')
        return this.closeModalAutorenewConfirm()
      }
      try {
        await this.enableAutorenew({ service_id: this.selectedService.id, service_type: this.selectedService.type, cancellation_id: this.crId })
        if (this.goToRoute) {
          this.$router.push({ path: this.goToRoute })
        }
      } catch (error) {
        this.reportError(error)
      }
    },

    autorenewConfirmModalOpen () {
      this.autorenewModalConfirmOpen = true
    },

    closeModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = false
      this.$emit('close')
    },
  }
}
</script>

<style scoped></style>
